import { Link } from "react-router-dom";
import { GraduationCap, Award, CalendarCheck, ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/motion";
import { DoctorsSection } from "../components/DoctorsSection";
import { TrustStrip } from "../components/sections";
import { DOCTOR } from "../lib/constants";

const Doctors = () => (
  <>
    <PageHero
      kicker="Our Doctors"
      testid="doctors-hero"
      lines={[
        <>Specialist doctors,</>,
        <>
          you can <span className="font-serif italic font-semibold text-brand-bright">trust</span>.
        </>,
      ]}
      sub="Every consultation at iNetra is led by specialist doctors — an AIIMS-trained retina & cataract surgeon and an internationally fellowship-trained oculoplastic surgeon."
    />

    <section className="py-20 sm:py-28" data-testid="doctors-list-section">
      <div className="container-x max-w-6xl">
        <DoctorsSection />
      </div>
    </section>

    <section className="pb-20 sm:pb-28" data-testid="doctors-trust-section">
      <div className="container-x max-w-6xl space-y-4">
        <Reveal>
          <div className="rounded-3xl border border-slate-200 bg-white overflow-hidden shadow-xl shadow-blue-900/5">
            <TrustStrip />
          </div>
        </Reveal>
        <div className="grid gap-4 md:grid-cols-2">
          <Reveal delay={0.08}>
            <div className="card-lift h-full rounded-2xl border border-slate-200 bg-white p-7">
              <GraduationCap className="w-6 h-6 text-brand-bright" strokeWidth={1.6} aria-hidden="true" />
              <h3 className="mt-4 text-base font-extrabold text-ink">Training</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{DOCTOR.training}</p>
            </div>
          </Reveal>
          <Reveal delay={0.16}>
            <div className="card-lift h-full rounded-2xl border border-slate-200 bg-white p-7">
              <Award className="w-6 h-6 text-aqua" strokeWidth={1.6} aria-hidden="true" />
              <h3 className="mt-4 text-base font-extrabold text-ink">Recognition</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{DOCTOR.faico}</p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <div className="rounded-3xl bg-ink text-white noise-dark relative overflow-hidden p-8 sm:p-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div className="relative">
              <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight">Meet your specialist in person</h2>
              <p className="relative mt-2 text-sm text-blue-100/80 max-w-lg">
                Explore Dr. Vikas's full credentials and recognitions, or book a consultation directly.
              </p>
            </div>
            <div className="relative flex flex-wrap gap-3 shrink-0">
              <Link to="/about" className="btn-outline !bg-transparent !text-white !border-white/25 hover:!border-white !text-[13px]" data-testid="doctors-about-button">
                Full Profile & Credentials <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </Link>
              <Link to="/contact#book" className="btn-primary !bg-aqua hover:!bg-aqua-bright !text-[13px]" data-testid="doctors-book-button">
                <CalendarCheck className="w-4 h-4" aria-hidden="true" /> Book Consultation
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Doctors;
